import services from './../../services/service'; // Service Class
import MainHeader from './../Main-Header/index.vue'; // Dashboard Header
import Sidebar from './../Sidebar/index.vue'; // Dashboard Sidebar
import MainFooter from './../Main-Footer/index.vue'; // Dashboard Footer
let service = new services();

export default {
    name: 'Cnpros',
    data () {
        return {
            admin:{},
            categories:{},
            category:{},
            img_url: service.imageURL,
            deleteRequest: false,
            editRequest: false,
            addRequest: false,
            disable_btn: false,
        }
    },
    components: {
        'component-header': MainHeader,
        'component-sidebar': Sidebar,
        'component-footer': MainFooter
    },
    methods: {
        //settings
        setComponent(attr,attr2) {
            this.panelFlag = true;
            if(attr == "add"){
                this.category = {};
                this.addRequest = true;
            }
            if(attr == "edit"){
                this.category = {};
                this.category = attr2;
                this.category.editRequest = true;
            }
            if(attr == "reset-action"){
                this.category = {};
                this.category.editRequest = false;
                this.addRequest = false;
                
            }
        },
        
        
        preset() {
            var credentials = {
                session_key: localStorage.getItem("cityneeds_a_token")
            } 
            if(credentials.session_key != null) {
                service.sessionGuard(this, credentials).then(response => {
                    if(response.body.status == 200) {
                        let data = response.body.data;
                        data.forEach(function(element) {
                            this.admin.admin_id = element.admin_id;
                        }, this);
                        }else {
                            this.$router.push('/');
                      }
                }).catch((err) => {
                    if(err) {
                     this.$router.push('/');
                    }
                })
            }else {
                this.$router.push('/');
            }
            
        },

        addBusinessCategory() {
            service.addBusinessCategory(this, this.category).then(data => {
               if(data.body.status == 201) {
                    this.getBusinessCategories();
                }
                this.addRequest = false;
                this.category = {}
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        getBusinessCategories() {
            service.getBusinessCategories(this).then(data => {
               if(data.body.status == 200) {
                    this.categories = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        editBusinessCategories(){
            service.editBusinessCategories(this, this.category.business_category_id, this.category).then(data => {
               if(data.body.status == 200) {
                  this.getBusinessCategories();
                  this.category.editRequest = false;
                }
            }).catch((err) => {
                if(err) {
                    toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },

        
    },
    created: function(){
        this.preset();
        this.getBusinessCategories();
    }
}


// WEBPACK FOOTER //
// ./src/components/BusinessCategories/script.js